import React, { useState } from "react";
import { PutObjectCommand } from "@aws-sdk/client-s3";
import minioClient, { BUCKET_NAME } from "../../../../../app/DB/connectMinio";
import { v4 as uuidv4 } from "uuid";

export default function UploadImage({
  ControllerProps,
  currentSheet,
  dispatchItemToredux,
}) {
  const { reduxKey } = ControllerProps;

  const [imageUpload, setImageUpload] = useState(null);
  const [fileName, setFileName] = useState("No file chosen");

  const uploadFile = async (file) => {
    if (file == null) return;

    const key = `images/${file.name}${uuidv4()}`;

    try {
      const command = new PutObjectCommand({
        Bucket: BUCKET_NAME,
        Key: key,
        Body: file,
        ContentType: file.type,
      });

      await minioClient.send(command);

      // Construct the public URL
      const url = `https://${process.env.REACT_APP_MINIO_ENDPOINT}/${BUCKET_NAME}/${key}`;

      // Dispatch the image URL to Redux
      dispatchItemToredux(url, reduxKey);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setImageUpload(file);
      setFileName(file.name);
      uploadFile(file);
    }
  };

  return (
    <div className="flex flex-col items-center w-full justify-start gap-2">
      {/* Custom button */}
      <label
        htmlFor="fileInput"
        className="px-2 py-1 bg-blue-950 text-white rounded cursor-pointer w-full"
      >
        Choose File
      </label>
      {/* Hidden file input */}
      <input
        id="fileInput"
        type="file"
        onChange={handleFileChange}
        className="hidden"
      />
      {/* Display selected file name */}
      <span className="text-gray-500 w-full text-left">{fileName}</span>
    </div>
  );
}